import React, { ReactNode, memo, useMemo } from 'react';

export const useLiveRegion = () => {
  function announce(role: 'status' | 'timer' | 'alert', message: string) {
    const current = globalThis.document?.querySelector(`[role="${role}"]`);
    if (!current) {
      return;
    }
    // KU – ensure screen-readers announce repeat messages
    // https://core.trac.wordpress.org/ticket/36853#comment:11
    current.innerHTML = current.innerHTML === message ? `\u00A0${message}` : message;
  }

  return useMemo(
    () => ({
      announceAlert: (string: string) => announce('alert', string),
      announceStatus: (string: string) => announce('status', string),
      announceTimer: (string: string) => announce('timer', string),
    }),
    [],
  );
};

const LiveRegionProvider = ({ children }: { children?: ReactNode }) => (
  <>
    <span className="visually-hidden" role="status" aria-live="polite" />
    <span className="visually-hidden" role="alert" />
    <span className="visually-hidden" role="timer" aria-live="polite" aria-atomic="true" />
    {children}
  </>
);

export default memo(LiveRegionProvider);
